// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OpuCcXWQxQdFl3FKIfu0 {
  /* Pin the bar to the bottom of the scrolling catalog/list view so it stays
     visible without scrolling to the end of a long table. It sticks to the
     bottom edge of the nearest scroll container (the detail panel's center
     column / bundle panel); the opaque background keeps rows from showing
     through as they scroll underneath. */
  position: sticky;
  bottom: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 42px;
  padding: 0 16px;
  background: #fafafa;
  border-top: 1px solid #ebebeb;
  box-shadow: 0 -1px 4px rgba(0, 0, 0, 0.04);
}

.vYpQ62FdFlgkux9irBPH {
  color: #888;
  font-size: 11px;
}

.LCQYLLJa6kzTZIy4peck {
  display: flex;
  align-items: center;
  gap: 6px;
}

.NpeV6rRen92KR61p2hRQ {
  min-width: 16px;
  color: #aaa;
  font-size: 11px;
  line-height: 1;
  text-align: center;
  user-select: none;
}

.AbXJVLMsaN61rmJi2IlV {
  min-width: 22px;
  height: 20px;
  border: 1px solid #ebebeb;
  border-radius: 4px;
  background: #fff;
  color: #888;
  font-size: 11px;
  line-height: 1;
  cursor: pointer;
  padding: 0 6px;
}

.AbXJVLMsaN61rmJi2IlV:hover:not(:disabled) {
  border-color: #d0d0d0;
  color: #555;
}

.AbXJVLMsaN61rmJi2IlV:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.o65BlaPZUoxZuXslBL5s {
  background: #1e1f23;
  border-color: #1e1f23;
  color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/components/datasets/catalog/PreviewPagination.module.css"],"names":[],"mappings":"AAAA;EACE;;;;yCAIuC;EACvC,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,6BAA6B;EAC7B,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb","sourcesContent":[".pagination {\n  /* Pin the bar to the bottom of the scrolling catalog/list view so it stays\n     visible without scrolling to the end of a long table. It sticks to the\n     bottom edge of the nearest scroll container (the detail panel's center\n     column / bundle panel); the opaque background keeps rows from showing\n     through as they scroll underneath. */\n  position: sticky;\n  bottom: 0;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  min-height: 42px;\n  padding: 0 16px;\n  background: #fafafa;\n  border-top: 1px solid #ebebeb;\n  box-shadow: 0 -1px 4px rgba(0, 0, 0, 0.04);\n}\n\n.paginationNote {\n  color: #888;\n  font-size: 11px;\n}\n\n.paginationControls {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.pageEllipsis {\n  min-width: 16px;\n  color: #aaa;\n  font-size: 11px;\n  line-height: 1;\n  text-align: center;\n  user-select: none;\n}\n\n.pageButton {\n  min-width: 22px;\n  height: 20px;\n  border: 1px solid #ebebeb;\n  border-radius: 4px;\n  background: #fff;\n  color: #888;\n  font-size: 11px;\n  line-height: 1;\n  cursor: pointer;\n  padding: 0 6px;\n}\n\n.pageButton:hover:not(:disabled) {\n  border-color: #d0d0d0;\n  color: #555;\n}\n\n.pageButton:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.pageButtonActive {\n  background: #1e1f23;\n  border-color: #1e1f23;\n  color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pagination": `OpuCcXWQxQdFl3FKIfu0`,
	"paginationNote": `vYpQ62FdFlgkux9irBPH`,
	"paginationControls": `LCQYLLJa6kzTZIy4peck`,
	"pageEllipsis": `NpeV6rRen92KR61p2hRQ`,
	"pageButton": `AbXJVLMsaN61rmJi2IlV`,
	"pageButtonActive": `o65BlaPZUoxZuXslBL5s`
};
export default ___CSS_LOADER_EXPORT___;
